// Registro del Service Worker propio (public/service-worker.js). No usa
// workbox ni CRA's cra-template-pwa (este proyecto no está "ejected" y no
// queremos agregar esa dependencia) — es un registro simple y explícito.
//
// onUpdate(registration): se llama cuando hay un SW nuevo instalado y
// esperando (waiting) — la UI (UpdateAvailableBanner) lo usa para ofrecer
// "Nueva versión disponible".

export function registerServiceWorker({ onUpdate } = {}) {
  if (!("serviceWorker" in navigator)) return;
  // Nunca en desarrollo: evita que un SW cacheado interfiera con el hot
  // reload de `npm start`.
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        registration.addEventListener("updatefound", () => {
          const installingWorker = registration.installing;
          if (!installingWorker) return;

          installingWorker.addEventListener("statechange", () => {
            if (installingWorker.state !== "installed") return;

            if (navigator.serviceWorker.controller) {
              // Ya había un SW controlando la página antes: esto es una
              // actualización real, no la primera instalación.
              if (onUpdate) onUpdate(registration);
            }
          });
        });
      })
      .catch(() => {
        // Registro fallido (offline en el primer load, etc.): la app sigue
        // funcionando normalmente, solo sin SW todavía.
      });
  });
}

// Activa el SW nuevo (que está en estado "waiting") y recarga una sola vez
// cuando toma control. No se pierde nada en localStorage/IndexedDB: el
// reload solo refresca los assets, los datos locales persisten.
export function applyServiceWorkerUpdate(registration) {
  const waiting = registration?.waiting;
  if (!waiting) return;

  let reloaded = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloaded) return;
    reloaded = true;
    window.location.reload();
  });

  waiting.postMessage("SKIP_WAITING");
}
